import LabelText from 'components/text/LabelText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const NavigationBoldText: FunctionComponent<Props> = props => {
    const { children = props.text, className = '', testId = TEST_ID } = props;

    return (
        <LabelText className={`${className} ${styles.navigationText}`} testId={testId}>
            {children}
        </LabelText>
    );
};

export default NavigationBoldText;
